import { FoodsTags } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";

type Props = {
    itemNb: number;
};
export const ItemTag = (props: Props) => {
    const { t } = useTranslation();
    const { itemNb } = props;

    return (
        <FoodsTags variant="tags-black" label={t("questionnaire.multivalue.item_tag", "Item {{itemNb}}", { itemNb })} />
    );
};
